
import { defineComponent, PropType } from 'vue';

type Variant = 'next' | 'pay';

export default defineComponent({
  name: 'WizardActionButton',

  props: {
    label: {
      type: String,
      required: true,
    },
    /** Leading icon class (e.g. `fa-regular fa-lock`). */
    icon: {
      type: String,
      default: '',
    },
    /** Trailing icon class (e.g. `fa-regular fa-arrow-right` for next CTAs). */
    trailingIcon: {
      type: String,
      default: '',
    },
    /** `next` = compact pill (Continuer →) ; `pay` = bigger CTA with lock. */
    variant: {
      type: String as PropType<Variant>,
      default: 'next',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingLabel: {
      type: String,
      default: '',
    },
  },

  emits: ['click'],
});
